import React, { useState } from "react";
import { Link } from "react-router-dom";
import pacewerksLogo from "./assets/pacewerks-logo.png";
import { FiMenu, FiX } from "react-icons/fi";
import "./Header.css";

const navLinkStyle = {
  color: "white",
  textDecoration: "none",
  fontWeight: 500,
  transition: "color 0.2s ease",
};

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const navItems = [
    { path: "/build", label: "Build" },
    { path: "/calculator", label: "Calculator" },
    { path: "/faq", label: "FAQ" },
    { path: "/blog", label: "PaceNotes" },
    // About: see footer. PaceNotes: re-add `{ path: "/pace-notes", label: "PaceNotes" }` when ready.
  ];

  return (
<header
  style={{
    background: "#111111",
    paddingTop: "1rem",     // ✅ Added vertical space
    paddingBottom: "1rem",  // ✅ Added vertical space
    paddingLeft: "1rem",
    paddingRight: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    zIndex: 1000,
    borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
  }}
>
  {/* Left: Hamburger Icon (mobile only) */}
  <div
    className="mobile-menu-icon"
    onClick={toggleMenu}
    style={{
      fontSize: "1.75rem",
      color: "white",
      cursor: "pointer",
      width: "2rem",
    }}
  >
    {menuOpen ? <FiX /> : <FiMenu />}
  </div>

  {/* Center: Logo (absolutely centered) */}
  <div
    style={{
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
    }}
  >
    <Link to="/" onClick={closeMenu}>
      <img
        src={pacewerksLogo}
        alt="PaceWerks"
        className="header-brand-logo"
        width={160}
        height="auto"
      />
    </Link>
  </div>

  {/* Right: Desktop Nav (right-aligned) */}
  <nav
    className="desktop-nav"
    style={{
      display: "flex",
      justifyContent: "flex-end", // ✅ Pushes links right
      gap: "1.5rem",
      flex: 1,                    // ✅ Takes up space to balance layout
    }}
  >
    {navItems.map(({ path, label }) => (
      <Link
        key={path}
        to={path}
        style={navLinkStyle}
        onClick={closeMenu}
        onMouseEnter={(e) => (e.target.style.color = "#00b894")}
        onMouseLeave={(e) => (e.target.style.color = "white")}
      >
        {label}
      </Link>
    ))}
  </nav>

  {/* Mobile Dropdown Menu */}
  {menuOpen && (
    <div
      className="mobile-menu"
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "100%",
        background: "#111111",
        padding: "1rem 2rem",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        borderTop: "1px solid rgba(255, 255, 255, 0.08)",
      }}
    >
      {navItems.map(({ path, label }) => (
        <Link
          key={path}
          to={path}
          onClick={closeMenu}
          style={{
            ...navLinkStyle,
            fontSize: "1.1rem",
          }}
          onMouseEnter={(e) => (e.target.style.color = "#00b894")}
          onMouseLeave={(e) => (e.target.style.color = "white")}
        >
          {label}
        </Link>
      ))}
    </div>
  )}
</header>
  );
}
